import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { DocumentationApiComponent } from './documentation-api/documentation-api.component';
import { FaqComponent } from './faq/faq.component';
import { ProdukComponent } from './produk/produk.component';
import { AuthGuard } from 'src/app/service/auth.guard';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'home',
        component: HomeComponent,
        canActivate:[AuthGuard]
      },
      {
        path: 'about',
        component: AboutComponent
      },
      {
        path: 'documentation-api',
        component: DocumentationApiComponent
      },
      {
        path: 'faq',
        component: FaqComponent
      },
      {
        path: 'product',
        component: ProdukComponent
      }
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LandingRoutingModule { }
